import { useInfiniteQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { UserKey } from './keys';
import { UserService } from './userService';

export function useGetUsersInfinite(name: string, enabled = true) {
  const getUsersInfiniteQuery = useInfiniteQuery({
    queryKey: [UserKey.USERS_INFINITE, name],
    queryFn: ({ pageParam }) => UserService.getUsers({ ...pageParam, name }).then((response) => response.data),
    initialPageParam: { page: 0, pageSize: 20, name: undefined },
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
      if (lastPage.length < lastPageParam.pageSize) {
        return undefined;
      }
      return { ...lastPageParam, page: lastPageParam.page + 1 };
    },
    enabled: enabled,
  });
  const errorMessage = useErrorMessage(getUsersInfiniteQuery.error);

  return { ...getUsersInfiniteQuery, errorMessage };
}
